import { openCalendlyPopup } from '../utils/calendly';

const CARDS = [
  {
    color: 'purple',
    title: 'We build the systems, not the decks',
    sub: 'No strategy docs. Delivered code.',
  },
  {
    color: 'teal',
    title: 'Live deployments only',
    sub: 'No experiments billed as deliverables',
  },
  {
    color: 'purple',
    title: 'One stack across Web3, AI, and automation',
    sub: 'No handoffs between specialists',
  },
  {
    color: 'teal',
    title: 'Direct access to builders',
    sub: 'No account managers. No translation layer.',
  },
];

const HowWeWork = () => (
  <section className="hww-section">
    <div className="hww-header">
      <h2 className="hww-title">How we work</h2>
      <div className="hww-rule" />
    </div>

    <div className="hww-grid">
      {CARDS.map((card, i) => (
        <div key={i} className={`hww-card hww-card--${card.color}`}>
          <p className="hww-card-title">{card.title}</p>
          <p className="hww-card-sub">{card.sub}</p>
        </div>
      ))}
    </div>

    <div className="hww-cta">
      <h3 className="hww-cta-title">Not sure which service fits your problem?</h3>
      <p className="hww-cta-body">
        30-minute call. No pitch. You describe what's broken — we tell you if we can build it.
      </p>
      <button type="button" onClick={openCalendlyPopup} className="hww-cta-btn">
        Let's talk
      </button>
    </div>
  </section>
);

export default HowWeWork;
